<template>
    <div>
        <!--        <div style="text-align: left">-->
        <!--            <el-select v-model="selectBattle" placeholder="请选择" @change="init">-->
        <!--                <el-option-->
        <!--                        v-for="battle in battleList"-->
        <!--                        :key="battle.pid"-->
        <!--                        :label="battle.battleTheme"-->
        <!--                        :value="battle.pid"-->
        <!--                        >-->
        <!--                </el-option>-->
        <!--            </el-select>-->
        <!--        </div>-->
        <!--        <TreeChart :json="projectNode" :class="{landscape: landscape.length}" :refresh="init" :parentIsEdit="1" />-->
        主页
    </div>
</template>

<script>

    export default {
        name: 'app',
        data() {
            return {}
        },
        methods: {

        },
        mounted() {

        }
    }
</script>

<style scoped>
    .foot {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        background: #333;
        padding: 24px;
        overflow: hidden;
        color: #999;
        font-size: 14px;
        text-align: center;
    }

    .foot a {
        color: #fff;
        margin: 0 .5em
    }
</style>
